<template>
  <figure
      class="relative w-64 cursor-pointer overflow-hidden rounded-xl border border-gray-950/[.1] bg-gray-950/[.01] p-4 hover:bg-gray-950/[.05] dark:border-gray-50/[.1] dark:bg-gray-accent/[.10] dark:hover:bg-gray-accent/[.15]"
  >
    <div class="flex flex-row items-center gap-2">
      <img
          :src="img"
          class="rounded-full"
          width="32"
          height="32"
          alt=""
      />
      <div class="flex flex-col">
        <span class="text-sm font-semibold dark:text-white">
          {{ name }}
        </span>
        <p class="text-xs font-semibold dark:text-white/40">{{ username }}</p>
      </div>
    </div>
    <blockquote class="mt-2 text-sm">{{ body }}</blockquote>
  </figure>
</template>

<script setup>
const props = defineProps({
  img: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  username: {
    type: String,
    required: true
  },
  body: {
    type: String,
    required: true
  }
});
</script>